/**
 * Service-level facts — SINGLE SOURCE OF TRUTH for every time promise shown
 * on the site. One base (Massa e Cozzile, PT) serves four regions, so arrival
 * times legitimately range from ~60 min (Valdinievole, Prato, Lucca) to
 * ~150 min (Grosseto, Amiata, southern Umbria). Never promise "entro un'ora"
 * globally: it is not true for most of the territory and auditors notice.
 */
export const SLA = {
  phoneAnswer_it: "Reperibilità telefonica H24",
  phoneAnswer_en: "Phone availability 24/7",
  arrival_it: "Tempi di intervento concordati al telefono in base a zona e disponibilità",
  arrival_en: "Visit times agreed by phone based on area and availability",
  arrivalShort_it: "Intervento da concordare al telefono",
  arrivalShort_en: "Visit scheduled by phone",
  callback_it: "Ti richiamiamo appena possibile",
  callback_en: "We call you back as soon as possible",
};

export function sla(key, lang = "it") {
  return SLA[`${key}_${lang === "en" ? "en" : "it"}`] || SLA[key] || "";
}
